import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Navbar } from "@/components/layout/Navbar.tsx";
import { Footer } from "@/components/layout/Footer.tsx";
import { useUserAuth } from "@/hooks/useUserAuth.ts";

export function UserAuthCallback() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isAuthenticated, loading } = useUserAuth();

  useEffect(() => {
    const authError = searchParams.get("error_description") || searchParams.get("error");
    if (authError) {
      navigate(`/login?authError=${encodeURIComponent(authError)}`, { replace: true });
      return;
    }

    if (!loading && isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, loading, navigate, searchParams]);

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="mx-auto mb-4 h-8 w-8 animate-spin" />
          <p className="text-muted-foreground">{t("userAuth.completingSignIn")}</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
